import { render, staticRenderFns } from "./Accounting.vue?vue&type=template&id=18e40aed&scoped=true&"
var script = {}
import style0 from "./Accounting.vue?vue&type=style&index=0&id=18e40aed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e40aed",
  null
  
)

export default component.exports